<template>
	<div>
		
		<div v-if="init" class="mb-8 my-6">

			<div v-if="currentUser" class="w-full my-8">
				<span v-if="!currentUser.archived && !currentUser.disabled" class="text-xs bg-blue-500 text-white p-1 rounded-md mr-1">Active</span>
				<span v-if="currentUser.archived" class="text-xs bg-gray-500 text-white p-1 rounded-md mr-1">Archived</span>
				<span v-if="currentUser.disabled" class="text-xs bg-red-500 text-white p-1 rounded-md">Disabled</span>
			</div>

			<div class="flex">

				<div class="w-5/12 pr-16">

					<form @submit.prevent="submitForm" action="#">

						<div class="flex items-center my-2">
							<div class="w-4/12">Full name:</div>
							<div class="w-5/12">
								<input v-model="form.name" class="form-input w-full" type="text" placeholder="Full name" required />
							</div>
						</div>
		
						<div class="flex items-center my-2">
							<div class="w-4/12">Personal number:</div>
							<div class="w-5/12">
								<input v-model.number="form.number" class="form-input w-1/2" type="number" required />
							</div>
						</div>						


						<div class="flex items-center my-2">
							<div class="w-4/12">Total vacation days:</div>
							<div class="w-5/12">
								<input v-model.number="form.totalVacationsDays" class="form-input w-1/2" type="number" step="0.5" />
							</div>
						</div>
						
		
						<div class="flex items-center my-2">
							<div class="w-4/12">Role:</div>
							<div class="w-5/12">
								<div ng-if="roles">
									<select class="form-input mr-1 w-full" v-model="form.role" required>
										<option value="" selected disabled>Select a role ...</option>
										<option v-for="role in roles" :key="role.id" :value="role.id">{{ role.name }}</option>
									</select>
								</div>
							</div>
						</div>


						<div class="flex items-center my-2">
							<div class="w-4/12">Part time:</div>
							<div class="w-1/12">
								<input v-model="form.isPartTime" type="checkbox" class="my-5" />
							</div>
							<div class="w-3/12" v-if="form.isPartTime">
								<select class="form-input mr-1 w-full" v-model="form.partTime">
									<option value="0" selected disabled>Select time ...</option>
									<option v-for="hours in partTimeHours" :value="hours">{{ hours }} hours</option>
								</select>
							</div>
							<div v-if="form.isPartTime" class="w-1/12 ml-1"> / day </div>
						</div>

						<div class="flex items-center my-2">
							<div class="w-4/12">External employee:</div>
							<div class="w-1/12">
								<input v-model="form.isExternal" type="checkbox" class="my-5" />
							</div>
						</div>


						<div v-if="isTeamLeader" class="flex items-center my-2">
							<div class="w-4/12 font-bold">Subordinates:</div>
							<div class="w-5/12">
								<select class="form-input mr-1 w-full" v-model="subordinate">
									<option value="" selected disabled>Select a subordinate ...</option>
									<option v-for="user in filteredUsers" :value="user.uid">{{ user.name }}</option>
								</select>
							</div>
							<div class="w-2/12">
								<button v-if="subordinate.length > 0" class="btn btn-info btn-small ml-4" @click.prevent="addSubordinate">Add</button>
							</div>
						</div>
		

						<div v-if="isTeamLeader" class="my-2">
							<div v-for="user in form.subordinates" class="flex items-center my-4">
								<div class="mr-4">
									<div class="flex items-center">
										<div class="text-red-500" @click.prevent="openModal(user)">
											<Zondicon icon="trash" class="w-4 mr-5 fill-current cursor-pointer" />
										</div>
										<div>
											<Zondicon icon="user" class="w-4 mr-5 fill-current" />
										</div>
										<div>
											{{ getUserName(user) }}
										</div>
									</div>
								</div>
							</div>
						</div>
		
						<div v-if="!uid">
							<div>
								<div colspan="2" class="pt-12 font-bold">Login credentials</div>
							</div>
			
							<div class="flex items-center my-2">
								<div class="w-4/12">Email:</div>
								<div class="w-5/12">
									<input readonly onfocus="this.removeAttribute('readonly');" v-model="user.email" class="form-input w-full" type="email" placeholder="Email" required />
								</div>
							</div>
			
							<div class="flex items-center my-2">
								<div class="w-4/12">Password:</div>
								<div class="w-5/12">
									<input readonly onfocus="this.removeAttribute('readonly');" v-model="user.password" class="form-input w-full" type="password" placeholder="Password" required minlength="6" />
								</div>
							</div>
						</div>


						<div class="mt-12 flex">

							<button v-if="uid" class="btn btn-secondary" type="submit">
								<div v-if="saving" class="loader"></div>
								<span v-else>Update</span>
							</button>
							<button v-if="!uid" class="btn btn-secondary" type="submit">
								<div v-if="saving" class="loader"></div>
								<span v-else>Save</span>
							</button>

							<router-link :to="{name: 'users'}" class="mr-2 btn">
								Back
							</router-link>
						</div>

					</form>

				</div>


				<div class="w-4/12" v-if="uid">

					<form @submit.prevent="emailModal = true" action="#">
						<div class="flex items-center my-2">
							<div class="w-4/12">Change email:</div>
							<div class="w-5/12">
								<input v-model="user.email" class="form-input w-full" type="email" placeholder="Enter new email" required />
							</div>
							<div class="w-2/12">
								<button class="btn btn-small btn-secondary ml-4" type="submit">Change</button>
							</div>
						</div>
					</form>

					<form @submit.prevent="passwordModal = true" action="#" class="mt-2">
						<div class="flex items-center my-2">
							<div class="w-4/12">Change password:</div>
							<div class="w-5/12">
								<input v-model="user.password" class="form-input w-full" type="password" placeholder="Enter new password" required minlength="6" />
							</div>
							<div class="w-2/12">
								<button class="btn btn-small btn-secondary ml-4" type="submit">Change</button>
							</div>
						</div>
					</form>

				</div>
			</div>

		</div>

		<div v-else class="loader loader-dark loader-big ml-4 mt-4 mr-0 mb-0"></div>

		<SimpleModal v-if="showModal" @action="removeSubordinate" @close="showModal = false" :btnClass="'btn-danger'">
            <template v-slot:title>Remove this subordinate</template>
            <template v-slot:body>Are you sure you want to remove this subordinate?</template>
            <template v-slot:button>Remove</template>
        </SimpleModal>

		<SimpleModal v-if="emailModal" @action="changeEmail" @close="emailModal = false" :btnClass="'btn-secondary'">
            <template v-slot:title>Change email address</template>
            <template v-slot:body>Are you sure you want to change the email address?</template>
            <template v-slot:button>Change</template>
        </SimpleModal>

		<SimpleModal v-if="passwordModal" @action="changePassword" @close="passwordModal = false" :btnClass="'btn-secondary'">
            <template v-slot:title>Change password</template>
            <template v-slot:body>Are you sure you want to change the password?</template>
            <template v-slot:button>Change</template>
        </SimpleModal>


	</div>
</template>

<script>
import { mapState } from "vuex";
import { db, auth } from "@/firebase";
import axios from 'axios'
import Zondicon from 'vue-zondicons'

import SimpleModal from '@/components/SimpleModal.vue'

export default {
	data() {
		return {
			uid: this.$route.params.uid,
			saving: 0,
			user: {
				email: '',
				password: ''
			},
			subordinate: '',
			form: {
				role: '',
				name: null,
				number: null,
				hourFrom: 7,
				minFrom: 0,
				subordinates: [],
				uid: '',
				isPartTime: false,
				partTime: 0,
				totalVacationsDays: 25
			},
			showModal: 0,
			emailModal: false,
			passwordModal: false,
			subordinateToRemove: null
		};
	},

	computed: {
		init() {
			if (this.roles && this.users) return true
			return false
		},

		...mapState([
			'roles',
			'users'
		]),

		currentUser() {
			if (this.users) return this.users.find(user => user.uid === this.uid)
		},

		partTimeHours() {
			var hours = []
			var from = 3;
			var to = 8
			for (let index = from; index < to; index++) {
				hours.push(index)
			}
			return hours;
		},

		isTeamLeader() {
			if (this.form.role === 'rPHdxrt3Uatga4u9jx5T') return true
			return false
		},

		filteredUsers() {
			var users = []

			// exclude superadmin
			users = this.users.filter(user => {
				if (user.role !== 'superadmin') return 1
			})

			// exclude subordinates
			users = users.filter(user => {
				if (this.form.subordinates.indexOf(user.uid) > -1) return 0
				return 1
			})

			users = users.sort((a, b) => {
				return a.name.localeCompare(b.name)
			})

			return users;
		}
	},

	components: {
		SimpleModal,
		Zondicon
	},

	watch: {
		users(newValue, oldValue) {
			this.updateForm()
		} 
	},

	methods: {

		submitForm() {
			if (this.uid) {
				this.updateUser()
			} else {
				this.saveUser()
			}
		},

		saveUser() {
			this.saving = 1;

			// first create user in firebase admin
			axios(
				{
					method: 'post',
					url: `${process.env.VUE_APP_CLOUD_FUNCTIONS_URL}/user`,
					auth: {
						username: process.env.VUE_APP_CLOUD_FUNCTIONS_USERNAME,
						password: process.env.VUE_APP_CLOUD_FUNCTIONS_PASSWORD
					},
					data: {
						email: this.user.email,
						password: this.user.password
					}
				}
			)
			.then(res => {

				if (res.data.created) {
					this.form.uid = res.data.uid
					// then create user data in firestore
					db
						.collection('users')
						.doc(this.form.uid)
						.set(this.form)
						.then(res => {
							this.saving = 0;
							this.$router.replace({name: 'users'})
							this.$toasted.show('User was created successfully!', {
								type: 'success'
							})
						})
						.catch(error => {
							this.saving = 0;
							this.$toasted.show(error, {
								type: 'error'
							})
						});

				} else {
					this.saving = 0;
					this.$toasted.show(res.data.message, {
						type: 'error'
					})
				}

			})
			.catch(error => {
				this.saving = 0;
				this.$toasted.show(error, {
					type: 'error'
				})
			})

		},

		updateUser() {

			this.saving = 1;

			db
			.collection('users')
			.doc(this.uid)
			.set(this.form)
			.then(res => {
				this.saving = 0;
				this.$toasted.show('User was updated successfully!', {
					type: 'success'
				})
			})
			.catch(error => {
				this.saving = 0;
				this.$toasted.show(error, {
					type: 'error'
				})
			});

		},

		updateForm() {
			if (this.uid && this.users) {
				this.form = this.users.find(user => user.uid === this.uid)
			}
		},

		addSubordinate() {
			this.form.subordinates.push(this.subordinate)
			this.subordinate = ''
		},

		removeSubordinate() {
			this.form.subordinates.splice(this.form.subordinates.indexOf(this.subordinateToRemove), 1)
			this.showModal = 0
		},

		openModal(id) {
			this.subordinateToRemove = id
			this.showModal = 1
		},

		closeModal() {
			this.showModal = 0
		},

		getUserName(id) {
			return this.users.find(user => user.uid === id).name
		},

		changeEmail() {

			axios(
				{
					method: 'put',
					url: `${process.env.VUE_APP_CLOUD_FUNCTIONS_URL}/user`,
					auth: {
						username: process.env.VUE_APP_CLOUD_FUNCTIONS_USERNAME,
						password: process.env.VUE_APP_CLOUD_FUNCTIONS_PASSWORD
					},
					data: {
						uid: this.uid,
						data: {
							email: this.user.email
						}
					}
				}
			)
			.then(res => {
				if (res.data.updated) {
					this.emailModal = 0;
					this.$toasted.show('Email address was changed successfully!', {
						type: 'success'
					})
				} else {
					this.emailModal = 0;
					this.$toasted.show(res.data.message, {
						type: 'error'
					})
				}
			})
			.catch(error => {
				this.emailModal = 0;
				this.$toasted.show(error, {
					type: 'error'
				})
			})

		},

		changePassword() {
			axios(
				{
					method: 'put',
					url: `${process.env.VUE_APP_CLOUD_FUNCTIONS_URL}/user`,
					auth: {
						username: process.env.VUE_APP_CLOUD_FUNCTIONS_USERNAME,
						password: process.env.VUE_APP_CLOUD_FUNCTIONS_PASSWORD
					},
					data: {
						uid: this.uid,
						data: {
							password: this.user.password
						}
					}
				}
			)
			.then(res => {
				if (res.data.updated) {
					this.passwordModal = 0;
					this.$toasted.show('Password was changed successfully!', {
						type: 'success'
					})
				} else {
					this.passwordModal = 0;
					this.$toasted.show(res.data.message, {
						type: 'error'
					})
				}
			})
			.catch(error => {
				this.passwordModal = 0;
				this.$toasted.show(error, {
					type: 'error'
				})
			})
		}

	},

	created() {
		if (!this.users) this.$store.dispatch('getUsers')
		if (!this.roles) this.$store.dispatch('getRoles')
		this.updateForm()

		// prefill new user number
		if (this.users && !this.currentUser) {
			
			// users without large numbers
			var users = this.users.filter(user => user.number < 999 && user.number);
			var numbers = users.map(user => parseFloat(user.number));
			this.form.number = Math.max(...numbers) + 1;

		}

		if (this.uid) this.$store.commit('SET_TITLE', 'Edit user')
		else this.$store.commit('SET_TITLE', 'Create new user')
	}
};
</script>